export default "__VITE_ASSET__vXn5K5HW__"